import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Tag = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M15 11C16.1046 11 17 10.1046 17 9C17 7.89543 16.1046 7 15 7C13.8954 7 13 7.89543 13 9C13 10.1046 13.8954 11 15 11Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M13.3284 2.5C12.798 2.5 12.2893 2.71071 11.9142 3.08579L2.91422 12.0858C2.13317 12.8668 2.13317 14.1332 2.91422 14.9142L9.10277 21.1028C9.87716 21.8772 11.1303 21.8847 11.914 21.1197L20.897 12.3512C21.2826 11.9748 21.5 11.4588 21.5 10.92V4.5C21.5 3.39543 20.6046 2.5 19.5 2.5H13.3284ZM19.5 4.5V10.92L10.517 19.6886L4.32843 13.5L13.3284 4.5L19.5 4.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Tag;
